import { TextSize } from "component-utils/text-types";
import type { RuntimeTheme } from "../../../lib/theme/core-themes/runtime-theme";
import { styled } from "../../../styled-components";

function subtitleSize(textSize: TextSize, theme: RuntimeTheme) {
    switch (textSize) {
        case TextSize.Small:
            return theme.fontStyles.Body6;
        case TextSize.Large:
            return theme.fontStyles.Body4;
    }
    return theme.fontStyles.Body5;
}

function titleSize(textSize: TextSize, theme: RuntimeTheme) {
    switch (textSize) {
        case TextSize.Small:
            return theme.fontStyles.AccentBody5;
        case TextSize.Large:
            return theme.fontStyles.AccentBody3;
    }
    return theme.fontStyles.AccentBody4;
}

interface Props {
    imageScaler: number;
    numTextLines: number;
    textSize: TextSize;
    needsOverlayPadding: boolean;
}
export const CardItemViewStyle = styled.div<Props>`
    position: relative;

    display: flex;
    flex-direction: column;
    overflow: hidden;

    &.float {
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
    }

    &.outline::after {
        content: "";
        pointer-events: none;
        position: absolute;
        left: 0;
        top: 0%;
        width: 100%;
        height: 100%;

        border-radius: 0px;
        border: 1px solid ${p => p.theme.separatorColor};
    }

    &.rounded.outline::after {
        border-radius: 8px;
    }

    &.no-float .bottom-area {
        background-color: transparent;
    }

    &.rounded {
        border-radius: 8px;
    }

    &.horizontal.float {
        margin-bottom: 12px;
    }

    .card-image-container {
        position: relative;
        width: 100%;
        padding-bottom: ${p => p.imageScaler * 100}%;
    }

    &.all-caps .card-title {
        text-transform: lowercase;
        font-variant: all-small-caps;
    }

    .image-skeleton {
        background-color: ${p => p.theme.skeletonColor};
    }

    .image,
    .image-skeleton {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;

        object-fit: cover;
    }

    .overlays {
        color: white;
    }

    .bottom-area {
        display: flex;
        flex-direction: column;

        background-color: ${p => p.theme.cards.bgColor};
        padding: ${p => (p.needsOverlayPadding ? 40 : 12)}px 12px 12px 12px;
        color: ${p => p.theme.fgColorDark};

        flex-grow: 1;
    }

    .tile-corner-container {
        padding: 12px;
    }

    .card-spacer {
        flex-grow: 1;
    }

    .card-title-container {
        :not(:last-child) {
            margin-bottom: 4px;
        }
    }

    .card-header {
        ${p => p.theme.fontStyles.Tag5}

        color: ${p => p.theme.primaryAccentColor};

        :not(:last-child) {
            margin-bottom: 4px;
        }

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .card-title {
        ${p => titleSize(p.textSize, p.theme)};

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .card-subtitle {
        ${p => subtitleSize(p.textSize, p.theme)};
        color: ${p => p.theme.fgColorMedium};

        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: ${p => p.numTextLines};
        overflow: hidden;

        :not(:last-child) {
            margin-bottom: 4px;
        }
    }

    .card-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;

        > *:first-child:not(:last-child) {
            margin-right: 28px;
        }

        > * {
            min-width: 20px;
            flex-shrink: 1;
            flex-grow: 1;

            > * {
                max-width: 100%;
            }
        }

        .bottom-left-overlay {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
        }

        .bottom-right-overlay {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
        }
    }
`;
